import React from "react";

const ConfirmationModal = ({ message, onConfirm, onCancel }) => {
    return (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
                <p className="text-lg mb-4">{message}</p>
                <div className="flex justify-between">
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-[#2A668D] text-white rounded-md"
                    >
                        Yes
                    </button>
                    <button
                        onClick={onCancel}

                        className="px-4 py-2 bg-[#2A668D] text-white rounded-md"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
